var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataPlots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8919 8.75L15.1075 8.75C14.8176 8.75 14.583 9.03769 14.583 9.39313L14.583 32.8985C14.583 33.254 14.8176 33.5417 15.1075 33.5417L19.8919 33.5417C20.1817 33.5417 20.4163 33.254 20.4163 32.8985L20.4163 9.39313C20.4163 9.03769 20.1817 8.75 19.8919 8.75Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5588 1.45837L26.7745 1.45837C26.4846 1.45837 26.25 1.74843 26.25 2.10679L26.25 32.8933C26.25 33.2516 26.4846 33.5417 26.7745 33.5417L31.5588 33.5417C31.8487 33.5417 32.0833 33.2516 32.0833 32.8933L32.0833 2.10679C32.0833 1.74843 31.8484 1.45837 31.5588 1.45837Z",
    fill: "#1E2447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.68385 4.375L4.89949 4.375C4.60962 4.375 4.375 4.67033 4.375 5.0352L4.375 32.8815C4.375 33.2463 4.60962 33.5417 4.89949 33.5417L9.68385 33.5417C9.97371 33.5417 10.2083 33.2463 10.2083 32.8815L10.2083 5.0352C10.2083 4.67033 9.97371 4.375 9.68385 4.375Z",
    fill: "#1E2447"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPlots);
export default __webpack_public_path__ + "static/media/data_plots.c941b7c6.svg";
export { ForwardRef as ReactComponent };